import React from 'react';
import Stripe from '../Stripe';
import Title from '../Title';

// Styles
import styles from './index.module.sass';

export default function MujeresExitosas(props) {
  const { device = {} } = props;
  const { screenSize = 'desktop' } = device;

  return (
    <div id={styles.Catalog} className={styles[screenSize]}>
      <Title
        device={device}
        title='En compañía de Mujeres Exitosas'
        subtitle='Haciendo felices al mayor número de personas posible'
      />
      <Stripe device={device} />
      <div className={styles.documentsContainer}>
        <div className={styles.document}>
          <img
            src='https://docs.terramarbrands.com.mx/MujeresExitosas/Edicion1.jpg'
            alt='Edicion1'
          />
          <a
            href='https://docs.terramarbrands.com.mx/MujeresExitosas/Libro-Terramar-I-Edicion.pdf'
            target='_blank'
            rel='noopener noreferrer'
            className={styles.button}>
            I Edición
          </a>
        </div>

        <div className={styles.document}>
          <img
            src='https://docs.terramarbrands.com.mx/MujeresExitosas/Edicion2.jpg'
            alt='Edicion2'
          />
          <a
            href='https://docs.terramarbrands.com.mx/MujeresExitosas/Libro-Terramar-II-Edicion.pdf'
            target='_blank'
            rel='noopener noreferrer'
            className={styles.button}>
            II Edición
          </a>
        </div>
      </div>
    </div>
  );
}
